import { makeGenericToken } from './util.make-generic-token.js';

function makeScaleableToken(propName, input) {
  const defaultValue = typeof input === "function" ? input() : input;
  return makeGenericToken(function format(options) {
    const rawValue = `var(${propName}, ${defaultValue})`;
    return options?.scale === undefined ? rawValue : `calc(${options.scale} * ${rawValue})`;
  }, function override(nextValue) {
    if (nextValue === undefined) {
      return {};
    }
    return {
      [propName]: typeof nextValue === "function" ? nextValue() : String(nextValue)
    };
  }, function extend(propName, token) {
    return makeScaleableToken(propName, token());
  }, {
    propName,
    defaultValue
  });
}

export { makeScaleableToken };
//# sourceMappingURL=token.scaleable.js.map
